<script setup lang="ts">
import { socketEmitAsync } from '@/utils/web-socket'
import { ref } from 'vue'
import { useCommonStore } from '@/stores/modules/common'
import { watch } from 'vue'
import { computed } from 'vue'
import { nianMonsterRewardList } from '../data'

const commonStore = useCommonStore()

const fightCount = ref(0)
const rewardCount = ref(0)
async function getFightCount() {
  const res = await socketEmitAsync<{ fightCount: number; groupCode: string; rewardCount: number }>({ type: 'getNianMonsterFightCount' })
  fightCount.value = res.fightCount
  rewardCount.value = res.rewardCount
}
function getTrColor(count: number, index: number) {
  if (count > (fightCount.value || 0)) {
    return 'var(--el-color-danger-light-5)'
  } else if (index <= (rewardCount.value || 0)) {
    return 'var(--el-color-warning-light-5)'
  } else {
    return 'var(--el-color-success-light-5)'
  }
}
const canReceive = computed(() => {
  const count = fightCount.value
  if (!count) return false
  for (const i in nianMonsterRewardList) {
    const item = nianMonsterRewardList[i]
    if (rewardCount.value >= Number(i) + 1) continue
    if (count >= item.count) return true
  }
  return false
})
async function handleReceive() {
  const res = await socketEmitAsync<number>({ type: 'nianMonsterReceiveReward' })
  commonStore.celebrationPoint = res
  getFightCount()
  ElMessage.success('领取成功')
}

watch(
  () => commonStore.path,
  (val) => {
    if (val === 'OneYear') {
      getFightCount()
    }
  },
)
</script>

<template>
  <div class="border-wrap affix" style="margin-bottom: 10px">
    <h4>共斗年兽</h4>
    <p>1. 新春庆典期间，<span class="special">特别挑战</span>中将开放<span class="info">共斗年兽</span>副本，<b>全服</b>共享血量。</p>
    <p>
      2. 参与共斗年兽将获得<span class="info">💲 活动积分</span>奖励；参与及击退年兽时，将获得<span class="gold">金币</span>及<span class="diamond"
        >钻石</span
      >奖励。
    </p>
    <p>3. 共斗年兽挑战次数<span class="info">每日 0点</span>刷新 <span class="grow">1</span>次，来与全服玩家共同击退年兽！</p>
    <p></p>
  </div>
  <div class="border-wrap affix" style="margin-bottom: 10px">
    <h4>累计参与奖励</h4>
    <p>已参与次数：{{ fightCount }}</p>
    <table border style="width: 100%; text-align: center">
      <tr>
        <td>参与次数</td>
        <td>奖励</td>
      </tr>
      <tr v-for="(item, index) of nianMonsterRewardList.slice(0, 5)" :style="{ backgroundColor: getTrColor(item.count, index + 1) }">
        <td>{{ item.count }}</td>
        <td>💲 活动积分: {{ item.point }}</td>
      </tr>
      <tr :style="{ backgroundColor: getTrColor(666, 7) }">
        <td>16</td>
        <td>
          <span style="background-color: #333">
            <span class="nickname" style="background: linear-gradient(135deg, #a8e6cf 0%, #dcedc1 100%); padding: 0 3px">春意盎然昵称颜色</span>
          </span>
        </td>
      </tr>
    </table>
    <el-button type="success" plain @click="handleReceive" style="width: 100%; margin-top: 10px" :disabled="!canReceive">领取奖励</el-button>
  </div>
</template>

<style lang="scss" scoped>
.border-wrap {
  padding: 10px;
  p {
    margin: 5px 0;
    font-size: 14px;
  }
}
</style>
